import Api from "../api";
import qs from "qs";
import { PaginationRequestType } from "@/entity/common/pagination.types";
import { ResponseDataType, VisitResponseDataType } from "@/form/form.types";
import { IVisitsRepository } from "./VisitsRepository.types";
import Visits from "@/entity/visits/visit";
import { IVisits, IVisitsListItem, VisitsResponseType, VisitPaymentMethods } from "@/entity/visits/visit.types";
import {NewVisitCreateRequestType, VisitCreateRequestType} from "@/form/visits/visitCreate.types";
import { VisitTypePayRequestType } from '@/form/visits/Pay/Visit.types';
import { VisitProduct } from "@/entity/visits/vProducts";
import { visitProductsRequestType } from '@/form/visits/Products/visitProducts.types'


export class VisitsRepository implements IVisitsRepository{
    async fetchAll(data?: FormData): Promise<IVisits>{

        const response = await Api.get('/visits/get', {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return new URLSearchParams(params).toString()
            }});

        const responseData = response.data as VisitsResponseType;

        return new Visits(responseData);
    }

    async fetchData(data: PaginationRequestType): Promise<IVisitsListItem> {
        const response = await Api.get(`/visits/get`, {
            params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }});
        const responseData = response.data as VisitsResponseType;
        return new Visits(responseData).data[0];
    }

    async fetchVisitProducts(visit_id:number):Promise<VisitProduct[]>{
        const response = await Api.get(`/visits/product/get?visit_id=`+String(visit_id));
        return response.data
    }

    async saveVisitProducts(data: visitProductsRequestType):Promise<ResponseDataType> {
        const response = await  Api.post(`/visits/product/save`, data);
        return  response.data
    }

    async createNew(data: NewVisitCreateRequestType): Promise<VisitResponseDataType> {
        const response = await Api.post(`/visits/create`, data);
        return response.data;
        //return responseData;
    }
    async updateNew(data: NewVisitCreateRequestType): Promise<VisitResponseDataType> {
        const response = await Api.post(`/visits/update`, data);
        return response.data;
    }

    async create(data: VisitCreateRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/visits/create`, data);
        return response.data;

    }
    async update(data: VisitCreateRequestType): Promise<ResponseDataType> {
        console.log('++++++++++++++++++++1676393764++++++++++++++++++++++++');console.log('data : ' + (typeof data));console.log(data);console.log('--------------------1676393764------------------------');

        const response = await Api.post(`/visits/update`, data);
        return response.data;
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const response = await Api.post(`/visits/cancel`, data);
        return  response.data;
    }
    async pay(data: VisitTypePayRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/visits/payment/execute`, data);
        return  response.data;
    }
    async fetchPaymentMethods(data: {visit_id: number}): Promise<VisitPaymentMethods> {
        const response = await Api.get(`/visits/payment/get_methods`, {
            params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }});
        return  response.data;
        //return responseData;
    }
}